<template>
    <!-- main container -->
    <v-container fluid>
        <div>
            <h4>{{ $t('ausnahmen') }} <IconBtn icon-cls="new" icon-color="grey" @click="onAdd" /></h4>
        </div>
        <div class="exceptions-list">
            <v-row v-for="(exception, i) in record.exceptions" :key="i" class="exception-field" dense>
                <v-col cols="12" sm="3">
                    <DateTextfield
                        :value="exception.start_date"
                        :placeholder="$t('start_date')"
                        :rules="getRules('required')"
                        hide-details="auto"
                        input-class="date-field"
                        @input="exception.start_date = $event"
                    />
                </v-col>
                <v-col cols="12" sm="3">
                    <DateTextfield
                        :value="exception.end_date"
                        :placeholder="$t('end_date')"
                        :rules="getRules('required')"
                        hide-details="auto"
                        input-class="date-field"
                        @input="exception.end_date = $event"
                    />
                </v-col>
                <v-col cols="12" sm="6" class="d-flex">
                    <v-text-field
                        v-model="exception.description"
                        dense
                        outlined
                        hide-details="auto"
                        :placeholder="$t('description')"
                        style="flex-basis: 250px"
                    />
                    <IconBtn icon-cls="delete" icon-color="grey" @click="removeException(exception)" />
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { userIsStaff } from '@/helpers/auth';
import { Schedule } from '@/models/Schedule';
import getRulesMixin from '@/mixins/get-form-rules';
import dayjs from 'dayjs';

export default {
    name: 'ScheduleEditDialogExceptions',
    mixins: [getRulesMixin],
    props: {
        record: Schedule,
    },
    data() {
        return {};
    },
    computed: {},
    created() {
        // this.Event = Event;
        // this.Schedule = Schedule;
    },
    methods: {
        userIsStaff,
        onAdd() {
            let exceptions = [...this.record.exceptions];
            exceptions.push({
                start_date: dayjs(),
                end_date: dayjs(),
                description: '',
            });
            this.record.set('exceptions', exceptions);
        },
        removeException(exceptionEntry) {
            this.record.set(
                'exceptions',
                this.record.exceptions.filter((item) => item !== exceptionEntry),
            );
        },
        onInput(field, value) {
            const path = field.split('.');
            let currentField = null;
            let object = this.record;
            while ((currentField = path.shift())) {
                if (path.length > 0) {
                    object = object[currentField];
                } else {
                    object[currentField] = value;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
